<template>
    <div v-if="name" class="element el-line-chart can-change">
        <div class="chart">
            <canvas ref="canvas" :height="height"></canvas>
        </div>

		<!-- Display error div -->
		<div v-if="is_edit_mode && values && values.error" class="error-container edit-error">
			<div class='content-error'>{{values.error_message}}</div>
		</div>
		<div v-if="!is_edit_mode && values && values.error" class="error-container read-error">
			<div class='content-error'> {{values.error_message}} </div>
			
		</div>

		
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Chart from "chart.js";
import config from "@/components/study/editor/config/charts.json";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";

export default {
	name: "el-line-chart",
	mixins: [ ElementMixin ],
	data: function () {
		return {
		};
	},
	props: {
		name: {default: ""},
		values: Object,
		height: { default: 80 }
	},
	computed: {
		...mapGetters(["editor"]),
		is_edit_mode: function (){
			const result = this.editor.mode == "editing";
			return result;
		}
	},
	methods: {
		create: function () {
			const options = config[this.name].options;
			if (this.name == "volume_prix") {
				options.scales.yAxes[1].ticks["callback"] = function (value) { return value + " €"; };
			}

			// normalisation du contenu du tableau : mettre des 0 si aucune info à l'année
			const values = this.values;

			const temp_labels = values.labels.sort();
			if(temp_labels.length - 1 != parseInt(temp_labels[temp_labels.length - 1]) - parseInt(temp_labels[0])){
				const new_labels = [];

				// génération des nouveaux headers
				for(let i = parseInt(temp_labels[0]) ; i <= parseInt(temp_labels[temp_labels.length - 1]) ; i++){
					new_labels.push(i.toString());
				}

				// ajout des 0 dans les datasets
				values.datasets.forEach((dataset) => {
					const new_data = [];
					new_labels.forEach((label) => {
						if(values.labels.indexOf(label) > -1) {
							new_data.push(dataset.data[values.labels.indexOf(label)] || 0);
						} else {
							new_data.push(0);
						}
					});
					dataset.data = new_data;
				});
				values.labels = new_labels;
			} else {
				values.datasets.forEach((dataset) => {
					dataset.data.forEach((value_data, i) => {
						if(isNaN(value_data)){
							dataset.data[i] = 0;
						}
					});
				});
			}
			//Set min/max
			if(this.name == "evolution_loyers"){
				// options.scales.yAxes[0].ticks['min'] =5
				// options.scales.yAxes[0].ticks['max'] =20

				let min =0;
				let max = 20;
				let allValues =[];
				
				for (let i = 0 ; i<values.datasets.length;i++){
					
					allValues = [...allValues,...values.datasets[i].data];
				}
				// min  = (Math.round(Math.min(...allValues)/2)-2) *2;
				// max  = (Math.round(Math.max(...allValues)/2)+1) *2;
				min = Math.min(...allValues);
				max = Math.max(...allValues);


				min = Math.round(min)-2 ;
				max = Math.ceil(max)+1;


				options.scales.yAxes[0].ticks = {min: min, max: max,};

				options.scales.yAxes[0].ticks["callback"] = function (value) { return value + " €/m²"; };
				//options.spanGaps = false;
			}

			this.chart = new Chart(this.$refs.canvas, {
				type: config[this.name].type,
				data: values,
				options: options,
			});

			
		}
	},
	mounted: function () {
		this.create();
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.error-container
	z-index: 20000
	position absolute
	top 0
	left 0
	width 100% !important
	height 100% !important
	text-align center
	border-style solid
	border-width 2px
	.content-error
		position relative
		top 50%
		transform translateY(-50%)


.edit-error
	opacity 0.8
	background-color black
	color red
	border-color red

.read-error
	opacity 1
	background-color white
	color #3e5d58
	border-color #3e5d58
</style>
